<template>
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor
                    ref="titileInput"
                    class="titile-input"
                    v-model:valueData="dataList.title"
                    @focus="() => (tipsShow = true)"
                    @blur="() => (tipsShow = false)"
                />
            </div>
            <div class="content">
                <div class="score-box">
                    <div class="score-icon" v-for="(item, index) in 11" :key="index">
                        <div :class="dataList.icon == '1' ? 'score-icon_number score-icon_circular' : 'score-icon_number score-icon_square'">
                            {{ index }}
                        </div>
                        <div v-if="dataList.showScoreExplain" class="score-explain">
                            <span v-show="index === 0">{{ dataList.miniScoreExplain }}</span>
                            <span v-show="index + 1 === 11">{{ dataList.maxScoreExplain }}</span>
                        </div>
                    </div>
                </div>
                <!-- 题目聚焦时，出现提示框 -->
                <div v-show="tipsShow" class="title-tips">此题是判断客户推荐意愿的重要题目，修改题干请勿偏离“推荐意愿”原意。</div>
                <!-- 底部操作栏 -->
                <div class="footer-operation" v-if="footerShow">
                    <action-bar
                        class="action-bar"
                        @addCopy="() => emits('copyQuestion', dataList)"
                        @deleteQuestion="() => emits('deleteQuestion')"
                        @view="(e) => emits('singlePreview', e)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-nps">
// js
import { ref, watch, provide } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]); // 复制题目，删除题目, 数据改变, 单题预览;
const titileInput = ref(null);
// 提示信息是否展示
let tipsShow = ref(false);
watch(
    () => props.dataList,
    (curr, old) => {
        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);

// 可能会在外面改变内部输入框的聚焦情况
defineExpose({ titileInput });
provide("data", props.dataList);
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;
.content {
    .score-box {
        display: flex;
        .score-icon {
            width: 27px;
            min-height: 27px;
            margin-right: 25px;
            display: flex;
            flex-direction: column;
            white-space: nowrap;
            font-size: 14px;
            color: rgba(112, 120, 134, 1);
            .score-icon_number {
                width: 27px;
                height: 27px;
                border: 1px solid rgba(112, 120, 134, 1);
                color: rgba(102, 102, 102, 1);
                line-height: 25px;
                text-align: center;
            }
            .score-icon_circular {
                border-radius: 50%;
            }
            .score-icon_square {
                border-radius: 4px;
            }

            .score-explain {
                height: 18px;
                margin-top: 10px;
                color: rgba(112, 120, 134, 1);
                font-size: 12px;
                position: relative;

                span {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    &:nth-child(1) {
                        left: 0;
                    }
                    &:nth-child(2) {
                        right: 0;
                    }
                }
            }
        }
    }
}
</style>
